import { RelatorioComposicaoContasItem } from "../typings";

import http from "infra/http";
import { RelatorioComposicaoContasQueryParams } from "../typings";
import { useInfiniteQuery } from "react-query";
import { PaginateResult } from "core/resources/types/shared";
import { OperacaoEnum } from "resources/enums/conta";

function useRelatorioComposicaoReceitasInfiniteScroll(
  params: RelatorioComposicaoContasQueryParams,
  operacao: OperacaoEnum
) {
  return useInfiniteQuery(
    [`/v1/relatorios/financeiro/composicao-contas/paginado`, params, operacao],
    async ({ pageParam }) => {
      const { data } = await http.get<
        PaginateResult<RelatorioComposicaoContasItem> & { valorTotal: number }
      >(
        operacao === OperacaoEnum.Despesa
          ? "/v1/relatorios/financeiro/composicao-despesas/paginado"
          : "/v1/relatorios/financeiro/composicao-receitas/paginado",
        {
          params: { ...params, page: pageParam ?? 1 },
        }
      );

      return data;
    },
    {
      getNextPageParam: (lastPage) =>
        lastPage.meta.currentPage === lastPage.meta.totalPages
          ? undefined
          : lastPage.meta.currentPage + 1,
    }
  );
}

export default useRelatorioComposicaoReceitasInfiniteScroll;
